// viewId からビュー単体キャプチャに必要な SVG G 要素（ビュー本体・タイトルバー）を解決するレジストリ。
// タイトルバーは Teleporter で別レイヤーに描画されるため DOM query では確実に辿れない。
// そのため View コンポーネントがマウント中に自身の ref をここへ登録する
// （Locator パターン。MCPBridgeChatLocator と同様の方式）。
// ref はマウント直後やアンマウント途中で未確定になり得るため、参照時に getter で解決する。
export type ViewCaptureTarget = {
  getView: () => SVGGElement | null;
  getViewTitle: () => SVGGElement | null;
};

const targets = new Map<string, ViewCaptureTarget>();

export const ViewCaptureTargetLocator = {
  register(viewId: string, target: ViewCaptureTarget): void {
    targets.set(viewId, target);
  },
  // 古い cleanup が新しい登録を消さないよう、target 指定時は同一 target のときだけ解除する
  unregister(viewId: string, target?: ViewCaptureTarget): void {
    if (target === undefined || targets.get(viewId) === target) {
      targets.delete(viewId);
    }
  },
  find(viewId: string): ViewCaptureTarget | null {
    return targets.get(viewId) ?? null;
  },
};
